import React, { useState,useEffect,useContext } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Container,
  CssBaseline,
  Alert
} from '@mui/material';
import OrderReport from './reports/OrderReport'; 
import FinancialReport from './reports/FinancialReport';
import ShiftReport from './reports/ShiftReport';
import CustomerReport from './reports/CustomerReport';
import EndofDayReportContainer from './reports/EndofDayReportContainer';
import OverdueOrdersCard from './components/OverdueOrdersCard';
import DailyIncomeReport from './reports/DailyIncomeReport';
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Layout from "./Layout";
import AppContext from './AppContext';


const ReportDashboard = () => {
  const [value, setValue] = useState(0);
  const [isOffline, setIsOffline] = useState(false);
  const { shopId, t } = useContext(AppContext);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    // Add event listeners for online and offline events
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial status
    setIsOffline(!navigator.onLine);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <Layout>
 
    {isOffline && (
            <Alert severity="warning" sx={{ marginTop: '10px' }}>
              {t("You are offline. Some features may not be available.")}
            </Alert>
          )}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label={t("Report tabs")} variant="scrollable" scrollButtons="auto" >
          <Tab label={t("Daily Income Report")} />
          <Tab label={t("Financial Report")} />
          <Tab label={t("New Order Report")} />
          <Tab label={t("Overdue Order Report")} />
          <Tab label={t("End of Day Report")} />
          <Tab label={t("Shift Report")} />
          <Tab label={t("Customer Report")} />
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        {value === 0 && <DailyIncomeReport />}
        {value === 1 && <FinancialReport />}
        {value === 2 && <OrderReport />}
        {value === 3 && <OverdueOrdersCard />}
        {value === 4 && <EndofDayReportContainer shopId={shopId} />}
        {value === 5 && <ShiftReport />}
        {value === 6 && <CustomerReport />}
      </Box>
   
    </Layout>
    </ThemeProvider>
  );
};

export default ReportDashboard;
